import ajaxProducts from '@/ui/ui_ajax-products/products';
import ajaxProduct from '@/ui/ui_ajax-products/product';
import ajaxFilter from '@/ui/ui_ajax-filter';

export {
  ajaxProducts,
  ajaxProduct,
  ajaxFilter,
};
